import { IconChat, IconConstruction, IconFilledDatabase, IconMarkAsUnread, IconNotifications, IconWorkHome } from "@/assets/icons";
import { IconCompany } from "@/assets/icons/IconCompany";
import { IconConvert } from "@/assets/icons/IconConvert";
import { IconDashboard } from "@/assets/icons/IconDashboard";
import {
  AppRoutes,
  ChatRoutes,
  CompanyChatRoutes,
  CompanyContactRoutes,
  CompanyRoutes,
  ContactRoutes,
  ConvertRoutes,
  DashboardRoutes,
  InformationRoutes,
  MasterDataRoutes,
  RsoRoutes,
  SystemSettingRoutes,
} from "@/routes/config";
import { TMenu } from "@/types/menu";

export const menus: TMenu[] = [
  {
    text: "ダッシュボード",
    icon: IconDashboard,
    path: AppRoutes.home,
    relatedRoutes: DashboardRoutes,
  },
  {
    text: "自社支援",
    children: [
      {
        text: "受け入れ企業管理",
        icon: IconCompany,
        path: AppRoutes.companyList,
        relatedRoutes: CompanyRoutes,
      },
      {
        text: "提出形式の変換依頼",
        icon: IconConvert,
        path: AppRoutes.convert,
        relatedRoutes: ConvertRoutes,
      },
      { text: "お問い合わせ管理", icon: IconMarkAsUnread, path: AppRoutes.companyContactList, relatedRoutes: CompanyContactRoutes },
      { text: "チャット管理", icon: IconChat, path: AppRoutes.companyChat, relatedRoutes: CompanyChatRoutes },
    ],
  },
  {
    text: "RSO",
    children: [
      {
        text: "登録支援機関管理",
        icon: IconWorkHome,
        path: AppRoutes.rsoList,
        relatedRoutes: RsoRoutes,
      },
      { text: "お問い合わせ管理", icon: IconMarkAsUnread, path: AppRoutes.contactList, relatedRoutes: ContactRoutes },
      { text: "チャット管理", icon: IconChat, path: AppRoutes.chat, relatedRoutes: ChatRoutes },
    ],
  },
  {
    text: "システム管理",
    children: [
      { text: "お知らせ配信", icon: IconNotifications, path: AppRoutes.information, relatedRoutes: InformationRoutes },
      { text: "マスターデータ管理", icon: IconFilledDatabase, path: AppRoutes.masterData, relatedRoutes: MasterDataRoutes },
      { text: "システム設定", icon: IconConstruction, path: AppRoutes.setting, relatedRoutes: SystemSettingRoutes },
    ],
  },
] as const;
